/**
 * Promotion Service
 */
import { getApiClient } from '../apiClient';
import { PROMOTION_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetPromotionsResponse,
  GetPromotionsParams,
  GetPromotionResponse,
  CreatePromotionPayload,
  CreatePromotionResponse,
  UpdatePromotionPayload,
  UpdatePromotionResponse,
  DeletePromotionResponse,
} from '../types/promotion.types';

export const promotionService = {
  /**
   * Get all promotions with pagination and search
   */
  getPromotions: (params?: GetPromotionsParams): Promise<GetPromotionsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) {
      queryParams.append('page', String(params.page));
    }
    if (params?.limit) {
      queryParams.append('limit', String(params.limit));
    }
    if (params?.offset) {
      queryParams.append('offset', String(params.offset));
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status !== undefined) {
      queryParams.append('status', String(params.status));
    }
    const url = queryParams.toString()
      ? `${PROMOTION_ENDPOINTS.getPromotions}?${queryParams.toString()}`
      : PROMOTION_ENDPOINTS.getPromotions;
    return getApiClient().get(url);
  },

  /**
   * Get single promotion by ID
   */
  getPromotion: (id: string): Promise<GetPromotionResponse> => {
    const url = replacePathParams(PROMOTION_ENDPOINTS.getPromotion, { id });
    return getApiClient().get(url);
  },

  /**
   * Create promotion
   */
  createPromotion: (body: CreatePromotionPayload): Promise<CreatePromotionResponse> => {
    return getApiClient().post(PROMOTION_ENDPOINTS.createPromotion, body);
  },

  /**
   * Update promotion
   */
  updatePromotion: (id: string, body: UpdatePromotionPayload): Promise<UpdatePromotionResponse> => {
    const url = replacePathParams(PROMOTION_ENDPOINTS.updatePromotion, { id });
    return getApiClient().put(url, body);
  },

  /**
   * Delete promotion
   */
  deletePromotion: (id: string): Promise<DeletePromotionResponse> => {
    const url = replacePathParams(PROMOTION_ENDPOINTS.deletePromotion, { id });
    return getApiClient().delete(url);
  },
};
